import Text from 'components/_UI/Text';
import React from 'react';
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';

export default function BookingMap({ data }) {
    return (
        <Container>
            <Content>
                <Text name='title' paddingBottom={'20px'} color={colors.occasionalPurple}>Hospedagens</Text>
                
                <iframe
                    // src={`https://www.stay22.com/embed/gm?aid=&lat=${data?.lat}&lng=${data?.long}`}
                    src={`https://www.stay22.com/embed/gm?aid=whizr&lat=${data?.address?.lat}&lng=${data?.address?.long}`}
                    width="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    title="Mapa interativo de reservas"
                />
            </Content>
        </Container>

    );
}

const Container = styled(Column)`
    width: 100%;
    padding: 20px 3%;
    margin-bottom: 30px;
    margin-top: -10px;
    
    @media screen  and (min-width: ${breakpoints.lg}) {
        padding: 1%;
        margin-top: -20px;
    }
`;

const Content = styled(Column)`
    width: 100%;
    background-color: ${colors.neutralLight};
    box-shadow: 0 0 4px #ccc;
    padding: 30px;
    border-radius: 8px;
    border: 1px solid ${colors.neutralDark};

    & > iframe {
        height: 600px;
    }
    

    @media screen  and (min-width: ${breakpoints.lg}) {
        & > iframe {
            height: 540px;
        }
    }
`;